import { Radio } from '@client/new/components/basic';
import { Typography } from '@design-system/components/typography/typography';
import { Col, Row } from '@design-system/components/grid/grid';
import { ErrorMessage } from '@client/new/components/Label';
import { SelectProps } from './MenuSelect';
import React, { forwardRef } from 'react';

type Props = SelectProps<string> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > & { reversed?: boolean };
export const RadioSelect = forwardRef<HTMLInputElement, Props>(
  ({ error, ...p }, ref) => (
    <Col style={{ gap: 0 }}>
      <Row gap="s">
        {p.options.map((o, i) => {
          const label = (
            <Typography
              variant="body"
              size="medium"
              fontWeight="normal"
              color={o.disabled ? 'N-60' : undefined}
            >
              {o.label}
            </Typography>
          );
          const radio = (
            <Radio
              name={p.name}
              checked={p.value === o.value}
              value={o.value}
              disabled={o.disabled}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              ref={ref as any}
            />
          );
          return (
            <Row
              key={i}
              style={{
                cursor: o.disabled ? 'not-allowed' : 'pointer',
                alignItems: 'center',
              }}
              onClick={() => {
                if (o.disabled) return;
                p.onChange({
                  target: { name: p.name, value: o.value },
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } as any);
              }}
            >
              {p.reversed ? (
                <>
                  {radio}
                  {label}
                </>
              ) : (
                <>
                  {label}
                  {radio}
                </>
              )}
            </Row>
          );
        })}
      </Row>
      <ErrorMessage content={error} />
    </Col>
  ),
);
